import React, { Component } from 'react'
import { connect } from 'react-redux'
import {Input,DatePicker} from '../core'
import { UploadImageButton,UploadLisNoHead } from "../../components";
import utilityHelper from '../../helpers/helperUtil'
import moment from 'moment'
import {clearSearchDirectoryInfoAction} from '../../redux/actions/MasterAction'
import {saveTransactionAction} from '../../redux/actions/MainAction'
import {setKeyValueAction,clearModalAction} from '../../redux/actions/ModalEmployeeAction'
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"
import { getFileAction } from '../../redux/actions/UploadAction'
import {updateMR_DetailAction} from '../../redux/actions/MRAction'
const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};



class PanelNotApprove extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hamberger_status: initial_hamberger_status,
            isExpand : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
            ShowButton : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
            visibled : this.props.visibled === undefined || this.props.visibled=== true,
        };
        this.handleCollapse = this.handleCollapse.bind(this)
        this.searchEmployeeModal = this.searchEmployeeModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
       // this.formatDisplayEmployeeApprover = this.formatDisplayEmployeeApprover.bind(this)
    }

    handleCollapse() {
        window.$('#collapseItemOverview'+this.props.id).toggleClass('show');
        window.$('#collapseItemOverview'+this.props.id).focus();
        const {isExpand} = this.state;
        this.setState({...this.state,isExpand:!isExpand});

    }

    searchEmployeeModal(empCode, empName) {
        console.log("openSearch");
    
        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();
    
        this.props.setKeyValue('T_MR_DETAIL_NO_APPROVE', empCode, empName)

        window.$('#searchEmployeeModal').modal('show');
    
    }

    formatDisplayEmployeeApprover(empCode, empName) {
        const {
            t_MR_DETAIL,
            t_PO_COMMITTEE,
        } = this.props

        if (empCode !== null && empCode !== ''){

            let listError = []            

            return `${empName} (${empCode})`
        }
        else
            return ''

    }

    handleChange(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? true : false) : target.value;
        const name = target.name;
        // if (name === "invoic_description") {
        //     let { local_t_MR_IR_DESCRIPTION } = this.state
        //     if (valid) {
        //         this.setState({
        //             invoicDescription: value,
        //             ...this.state.local_t_MR_IR_DESCRIPTION,
        //             local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTION.map((data, i) => {
        //                 if (index === i) {
        //                     let updateItem = data
        //                     updateItem[name] = value
        //                     return updateItem
        //                 } else {
        //                     return data
        //                 }
        //             })
        //         });

        //         //this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
        //     }

        // } 
        // else {
            //check date
            if (target.className.indexOf("js-datepicker") > -1 && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }

            }

            if (name === "ref_no") {
                let { transaction_no } = this.props  
                this.props.getMrRefData(value, transaction_no)
                this.props.getMrRefDataVendor(value, transaction_no)
                this.props.getFile(value)
                if (value != "") {
                    this.setState({
                        viewMode: true,

                    })
                }
                else {
                    this.setState({
                        viewMode: false,

                    })

                }

            }
            if (valid) {
                this.props.updateMR_Detail(value, name)
            } else {
                return
            }
        // }
    }

    getTransNo(){
        let result;
        let {transaction_no} = this.state;
        let {temp_trans_att_no} = this.props;
        result= transaction_no;
        if(transaction_no == "" || transaction_no == null || transaction_no == undefined)
            result=temp_trans_att_no;

        return result;
    }

    render() {
        const {visibled} = this.state
        const {t_MR_DETAIL,t_HEADER,viewMode,transaction_no} = this.props
        return (
         visibled && (   <div  >
        <div className="sp-page-wrapper" >
            <div className="sp-table-container">
                <div className="showhide-detail-button" style={{backgroundColor:"#B6D0FB"}}>
                    <div className="btn-showhide-detail2">
                    <span>{this.props.tableName}</span>
                    </div>
                </div>
            </div>
        </div>
                <div >
                <div className="row rrs-fine-box">
                    <div className="col-12 d-md-flex align-items-start flex-wrap px-0"> 
                    <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_name">
                                <span className="required">*</span>ชื่อ-นามสกุล :
                                </label>
                            </div>
                    <div className="col-3 rrs_detial_data">
                            <div className = ""rrs-form>

                             <div className = "rrs-detail-data">


                                    <Input
                                            key={`approver_order_name${t_MR_DETAIL.transaction_no}`}
                                            value={this.formatDisplayEmployeeApprover(t_MR_DETAIL.approve_order_code, t_MR_DETAIL.approve_order_name)}
                                            className="form-control-search-2"
                                            id="approver_order_name"
                                            name="approver_order_name"
                                            onClick={() => this.searchEmployeeModal("approve_order_code", "approve_order_name")}
                                            readOnly={true}
                                            doctype="*"
                                            tagid="mr.approve_order_name"
                                            viewMode={true}
                                        />
                                 </div>   
                            </div>                          
                    </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_position">
                        ตำแหน่ง :
                        </label>
                    </div>
                    <div className="col-auto">
                    <Input
                            key={`approver_name${t_MR_DETAIL.approve_order_position}`}
                            value={t_MR_DETAIL.approve_order_position}
                            className="form-control form-control-search-2"
                            id="approve_order_position"
                            name="approve_order_position"
                            readOnly={true && !viewMode}
                            doctype="*"
                            tagid="mr.approve_order_position"
                            viewMode={true}

                    />
                    </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_telephone">
                        เบอร์โทร :
                        </label>
                    </div>
                    <div className="col-auto">
                    <Input
                            key={`approve_order_telephone${t_MR_DETAIL.approve_order_telephone}`}
                            value={t_MR_DETAIL.approve_order_telephone}
                            className="form-control form-control-search-2"
                            id="approve_order_telephone"
                            name="approve_order_telephone"
                            readOnly={true && !viewMode}
                            doctype="*"
                            tagid="mr.approve_order_telephone"
                            viewMode={true}

                    />
                    </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_email">
                        Email :
                        </label>
                    </div>
                    <div className="col-auto">
                    <Input
                            key={`approve_order_email${t_MR_DETAIL.approve_order_email}`}
                            value={t_MR_DETAIL.approve_order_email}
                            className="form-control form-control-search-2"
                            id="approve_order_email"
                            name="approve_order_email"
                            readOnly={true && !viewMode}
                            doctype="*"
                            tagid="mr.approve_order_email"
                            viewMode={true}
                    />
                    </div>
                     </div>
                </div>


                <div className="row rrs-fine-box">
                    <div className="col-12 d-md-flex align-items-start flex-wrap px-0"> 
                    <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_no">
                                <span className="required">*</span>ใบบันทึกเลขที่ :
                                </label>
                            </div>
                    <div className="col-auto">
                               
                    {/* <Input
                            key={`approve_order_no${t_MR_DETAIL.approve_order_no}`}
                            value={t_MR_DETAIL.approve_order_no}
                            className="form-control"
                            id="approve_order_no"
                            name="approve_order_no"
                            //readOnly={true && !viewMode}
                            onChange={this.handleChange}
                            //onBlur={this.handleChange}
                            doctype="*"
                            tagid="mr.approve_order_no"
                            viewMode={viewMode}
                            disabled={viewMode ? "disabled" : null} //{viewMode}
                            type="text"
                            /> */}
                          
                          <input
                           key={`approve_order_no${t_MR_DETAIL.approve_order_no}`}
                            name="approve_order_no"

                            className="form-control form-control-150 mr-3"
                            id="approve_order_no"
                            onBlur={this.handleChange} 
                            disabled={viewMode}

                            defaultValue={t_MR_DETAIL.approve_order_no}


                            />
                              
                            </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_no_date">
                        <span className="required">*</span>ลงวันที่ :
                        </label>
                    </div>
                    <div className="col-auto">
                    <DatePicker
                                    name="approve_order_no_date"
                                    id="approve_order_no_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    value={this.props.t_MR_DETAIL.approve_order_no_date
                                        ? moment(this.props.t_MR_DETAIL.approve_order_no_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    tagid="mr.approve_order_no_date"
                                    //disabled={viewMode}
                                    viewMode={viewMode}
                                    readOnly={true}
                                // showsdayall={"All"}
                                />
                    </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.approve_order_at_date">
                        <span className="required">*</span>วันที่ผู้มีอำนาจฯสั่งการ :
                        </label>
                    </div>
                    <div className="col-auto">
                    <DatePicker
                                    name="approve_order_at_date"
                                    id="approve_order_at_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    value={this.props.t_MR_DETAIL.approve_order_at_date
                                        ? moment(this.props.t_MR_DETAIL.approve_order_at_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    tagid="mr.approve_order_at_date"
                                    //disabled={viewMode}
                                    viewMode={viewMode}
                                    readOnly={true}
                                    showsdayall={"All"}
                                />
                    </div>
                    <div className="col-auto">
                        <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.penalty_amount_net">
                        <span className="required">*</span>
                        {/* <a href="#main" onClick={this.props.onClick}>  <i className="icon btn-save-order" /></a> */}
                          <UploadImageButton id= "imagebutton" 
                                transaction_no={this.getTransNo()}
                                modalId={'attachedNotApprove0032Modal'}
                                viewMode={viewMode}
                                defaultFileName={t_HEADER.product_type === "G"?"F-นจ.จบญ-0032":"F-นจ.จบญ-0038"}
                                file_category={'NA'}
                          ></UploadImageButton>
                          แนบแบบฟอร์ม {t_HEADER.product_type === "G"?"F-นจ.จบญ-0032":"F-นจ.จบญ-0038"}
                        </label>
                        <UploadLisNoHead 
                        key={"uploadlist-mr-" + utilityHelper.genDateKey()}
                        transaction_no={this.getTransNo()}
                        file_category={'NA'}
                        viewMode={viewMode}
                        isShow={false}
                        />
                    </div>
                    {/* <div className="col-auto">
                    <Input
                            key={`approver_name${t_MR_DETAIL.transaction_no}`}
                            value={this.formatDisplayEmployeeApprover(t_MR_DETAIL.approver_code, t_MR_DETAIL.approver_name)}
                            className="form-control form-control-search-2"
                            id="approver_name"
                            name="approver_name"
                            onClick={() => this.searchEmployeeModal("approver_code", "approver_name")}
                            readOnly={true && !viewMode}
                            doctype="*"
                            tagid="mr.approver"
                            viewMode={true}

                                        />
                    </div>
                     */}
                     </div>
                </div>

                </div> 
            </div>
         )
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        //viewMode : MainRedux.viewMode,
        transaction_no: MainRedux.transaction_no,
        temp_trans_att_no: MainRedux.temp_trans_att_no,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
        t_HEADER: MainRedux.t_HEADER,
        t_MR_ATTACHMENTS : MainRedux.t_MR_ATTACHMENTS,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        setKeyValue: (table, empCode, empName) => dispatch(setKeyValueAction(table, empCode, empName)),
        updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
        //updateMR_Attachment :(data,fieldName) => dispatch(updateMR_AttachmentAction(data,fieldName)),
        clearModal: () => dispatch(clearModalAction()),  
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
    }
}
    export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PanelNotApprove)
